import React, { Component } from "react";
import { connect } from "react-redux";
import { Table, Button } from "react-bootstrap";
import moment from "moment";

class LivingArrangementHistoryList extends Component {
  render() {
    const { action } = this.props;
    const livingArrangements = this.props.livingArrangements.filter((o) => !o._destroy);

    return (
      <Table size="sm" responsive>
        <thead>
          <tr>
            <th>Arrangement</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Notes</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {
            livingArrangements.map((l, i) => {
              return (
                <tr key={i}>
                  <td>{l.arrangement}</td>
                  <td>{l.started_at && moment(l.started_at).format("MM/DD/YYYY")}</td>
                  <td>{l.ended_at && moment(l.ended_at).format("MM/DD/YYYY")}</td>
                  <td>{l.notes}</td>
                  <td>
                    {
                      action === "edit" &&
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          this.props.editLivingArrangement(l);
                        }}>
                        Edit
                      </a>
                    }
                  </td>
                </tr>
              );
            })
          }
          {
            action == "edit" &&
            <tr>
              <td colSpan={7} className="text-center">
                <Button
                  variant="link"
                  onClick={() => {
                    this.props.newLivingArrangement();
                  }}>
                  Add Living Arrangement
                </Button>
              </td>
            </tr>
          }
        </tbody>
      </Table>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    isStaffApp: state.config.isStaffApp,
    livingArrangements: state.living_arrangement_histories,
    action: state.ui.action
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    newLivingArrangement: () => {
      dispatch({
        type: "NEW_RESOURCE",
        payload: { resourceName: "livingArrangementHistory" }
      })
    },
    editLivingArrangement: (resource) => {
      dispatch({
        type: "EDIT_RESOURCE",
        payload: { resourceName: "livingArrangementHistory", resource }
      })
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LivingArrangementHistoryList);
